import { Helmet } from "react-helmet"

function JugoistocnaEvropa() {
    return (
        <div className="flex-container full-width flex-grow-1">
             <Helmet>
                <title>Korisni linkovi - Jugoistocna Evropa</title>
                <meta
                    name="description"
                    content="Korisni linkovi vezani za jugoistočnu Evropu"
                    data-react-helmet="true" 
                />
            </Helmet>
            <p className="full-width padding-2p static-page-container">
                <a target="_blank"
                    rel='noreferrer'
                    href="https://historiografija.hr/"
                    className="full-width"    
                >
                    historiografija.hr
                </a>
                <br />
                <a target="_blank"
                    rel='noreferrer'
                    href="https://srednja-europa.hr/"
                    className="full-width"    
                >
                    srednja-europa.hr
                </a>
            </p>
        </div>
    )
}

export default JugoistocnaEvropa